import React from 'react';

import {useAllStores} from 'hooks/UserHook';
import StorePreview from 'views/designer/StorePreview';
import SetoCanvasPage from 'pages/SetoCanvasPage';

const AllStoresPage = () => {
    const allStores = useAllStores();
    const storePreviews = !allStores? []: allStores.map(store => <StorePreview key={store.storeName} store={store} />).toArray();
    
    return (
        <SetoCanvasPage id="allStoresPage" title={"Favourite artist's official Merch, T-shirt, Hoodies and all kinds of merchandise | Seto Canvas"} metaDescription={"Get your favourite artist merch, T-shirt, Hoodies and all kinds of merchandise at SetoCanvas.com"}>
            <div className="flexRow" style={{margin: '10px 0'}}>
                {storePreviews}
            </div>
        </SetoCanvasPage>
    );
};

export default AllStoresPage;


// WEBPACK FOOTER //
// ./src/pages/AllStoresPage.js